import React from 'react';
import { connect } from 'redux-bundler-react';
import classnames from 'classnames';
import TreeListContainer from './tree-list-container';

class TreeviewPanel extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      filterString: '',
      toggleExpanded: false,
      toggleVisible: false
    }
    this.toggleExpanded = this.toggleExpanded.bind(this);
    // this.toggleVisible = this.toggleVisible.bind(this);
  }

  toggleExpanded(){
    const { doTreeSetCollapsedAll, treeViewRootId } = this.props;
    this.setState({
      toggleExpanded: !this.state.toggleExpanded
    }, () => {
      doTreeSetCollapsedAll(treeViewRootId, this.state.toggleExpanded);
    });
  }

  // toggleVisible(){
  //   const { doTreeSetVisibleAll, treeViewRootId } = this.props;
  //   this.setState({
  //     toggleVisible: !this.state.toggleVisible
  //   }, () => {
  //     doTreeSetVisibleAll(treeViewRootId, this.state.toggleVisible);
  //   });
  // }

  render() {
    const { toggleExpanded, toggleVisible } = this.state;

    const toggleExpandedText = 'Expand / Collapse'
    const toggleExpandedIcon = classnames({
      "icon-inline": true,
      "mdi": true,
      "mdi-plus-box-outline": toggleExpanded,
      "mdi-minus-box-outline": !toggleExpanded
    });

    // const toggleVisibleText = 'Toggle All'
    // const toggleVisibleIcon = classnames({
    //   "icon-inline": true,
    //   "mdi": true,
    //   "mdi-checkbox-blank-outline": !toggleVisible,
    //   "mdi-checkbox-marked-outline": toggleVisible
    // });

    return (
      <div id="tree-view" className="sidebar-list thin-scrollbar">
        <div style={{ marginTop: 23, marginBottom: 10 }}>
          <button
            className="btn btn-default btn-xs"
            onClick={this.toggleExpanded}
            style={{ marginRight: '5px' }}
          >
            <i className={toggleExpandedIcon} />
            {toggleExpandedText}
          </button>
          {/* <button
            className="btn btn-default btn-xs"
            onClick={this.toggleVisible}
          >
            <i className={toggleVisibleIcon} />
            {toggleVisibleText}
          </button> */}
        </div>
          <TreeListContainer />
      </div>
    )
  }
}

export default connect(
  'selectTreeViewRootId',
  'doTreeSetCollapsedAll',
  'doTreeSetVisibleAll',
  TreeviewPanel
);